/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-res-btn.vue?vue&type=template&id=c574bd64&scoped=true&"
import script from "./add-res-btn.vue?vue&type=script&lang=js&"
export * from "./add-res-btn.vue?vue&type=script&lang=js&"
import style0 from "./add-res-btn.vue?vue&type=style&index=0&id=c574bd64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c574bd64",
  null
  
)

export default component.exports